import React from 'react';

import { FileProtectOutlined } from '@ant-design/icons';

function OrderCard({ data }) {
  const mapData = [
    {
      label: 'Chờ nhận từ ONP',
      total: data?.wONP || 0,
      url: '/orders-waiting-receive-from-ONP',
    },
    {
      label: 'Rvs từ ONP',
      total: data?.rONP || 0,
      url: '/orders-rvs-from-ONP',
    },
    {
      label: 'Hủy từ ONP',
      total: data?.cONP || 0,
      url: '/orders-cancel-from-ONP',
    },

    {
      label: 'Chờ nhận từ Kho',
      total: data?.wWMS || 0,
      url: '/orders-waiting-receive-from-WMS',
    },
    {
      label: 'Rvs từ Kho',
      total: data?.rWMS || 0,
      url: '/orders-rvs-from-WMS',
    },
    {
      label: 'Hủy từ Kho',
      total: data?.cWMS || 0,
      url: '/orders-cancel-from-WMS',
    },
  ];

  return (
    <div className='card'>
      <div className='card-header'>
        <FileProtectOutlined className='card-icon green' />
        <h3 className='card-title'>Danh Sách Đơn Hàng</h3>
      </div>

      {mapData.map((item) => {
        const clickable = item.total > 0;

        return (
          <div
            key={item.label}
            className={`row ${clickable ? 'clickable' : ''}`}
            onClick={clickable ? () => window.open(item.url, '_blank') : undefined}
          >
            <span>{item.label}</span>
            <b>{item.total}</b>
          </div>
        );
      })}
    </div>
  );
}

export default OrderCard;
